/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Description2Inputs */

const en_coinvestments_termsagreed_description2 = /** @type {(inputs: Coinvestments_Termsagreed_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your investment interest. The GP will review and confirm allocation.`)
};

/**
* | output |
* | --- |
* | "Review your investment interest. The GP will review and confirm allocation." |
*
* @param {Coinvestments_Termsagreed_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_description2 = /** @type {((inputs?: Coinvestments_Termsagreed_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_description2(inputs)
});
export { coinvestments_termsagreed_description2 as "coInvestments_termsAgreed_description" }